const reloadAttemptKey = 'lms.staleAssetReloadAt'
const reloadCooldownMs = 60_000

interface ReloadContext {
  readonly now: () => number
  readonly reload: () => void
  readonly storage: Pick<Storage, 'getItem' | 'setItem'> | null
}

export function isModuleLoadFailure(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error)
  return /Failed to fetch dynamically imported module|Importing a module script failed|Unable to preload CSS|Loading chunk .* failed/i.test(message)
}

export function attemptStaleAssetReload(error: unknown, context: ReloadContext): boolean {
  if (!isModuleLoadFailure(error) || !context.storage) {
    return false
  }

  try {
    const now = context.now()
    const lastAttempt = context.storage.getItem(reloadAttemptKey)
    if (lastAttempt !== null && now - Number(lastAttempt) < reloadCooldownMs) {
      return false
    }

    context.storage.setItem(reloadAttemptKey, String(now))
    context.reload()
    return true
  } catch {
    // Keep the visible recovery screen when browser storage or reload is blocked.
    return false
  }
}
